import { getToken } from '@/utils/auth'

const DEFAULT_TIMEOUT = 12000

function buildUrl(url, params) {
  if (!params || !Object.keys(params).length) {
    return url
  }

  const searchParams = new URLSearchParams()
  Object.keys(params).forEach((key) => {
    const value = params[key]
    if (value !== undefined && value !== null && value !== '') {
      searchParams.append(key, value)
    }
  })

  const queryString = searchParams.toString()
  if (!queryString) {
    return url
  }

  return `${url}${url.includes('?') ? '&' : '?'}${queryString}`
}

function normalizeResponse(payload) {
  if (payload && typeof payload === 'object') {
    if (payload.success === true) {
      return payload.data !== undefined ? payload.data : payload
    }

    if (payload.code === 0 || payload.code === 200) {
      return payload.data !== undefined ? payload.data : payload
    }

    if (payload.code && payload.code !== 0 && payload.code !== 200) {
      throw new Error(payload.msg || payload.message || '接口请求失败')
    }
  }

  return payload
}

function createTimeoutPromise(timeout) {
  return new Promise((_, reject) => {
    window.setTimeout(() => {
      reject(new Error('请求超时，请稍后重试'))
    }, timeout)
  })
}

export default function request(options) {
  const {
    url,
    method = 'GET',
    params,
    data,
    headers = {},
    timeout = DEFAULT_TIMEOUT,
    baseURL = process.env.VUE_APP_BASE_API || '/proxy-api'
  } = options

  const requestUrl = buildUrl(`${baseURL}${url}`, params)
  const token = getToken()

  const fetchPromise = fetch(requestUrl, {
    method,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...headers
    },
    body: method.toUpperCase() === 'GET' ? undefined : JSON.stringify(data || {})
  }).then(async (response) => {
    const contentType = response.headers.get('content-type') || ''
    const payload = contentType.includes('application/json')
      ? await response.json()
      : await response.text()

    if (!response.ok) {
      const errorMessage = payload && payload.message
        ? payload.message
        : `请求失败(${response.status})`
      throw new Error(errorMessage)
    }

    return normalizeResponse(payload)
  })

  return Promise.race([fetchPromise, createTimeoutPromise(timeout)])
}
